import { P2TextDescription } from "react-bootstrap-common-script";
import TextInfo from "../../components/text/text-info/text-info";
import { useAppSelector } from "../../redux/hook";
import { HoldingTypeEnum } from "../../models/enum/holding-type.enum";
import TenancyInCommonTable from "../application-coo/review-endorse/tenancy-in-common-table";
import { proposedHousingTypeItems } from "../../utils/shared-dropdown";
import QuestionAnswer from "./question-answer";
import { Stamp_Duty_Valuation } from "../../utils/shared-radio";
import { StampDutyValuationEnum } from "../../models/enum/stamp-duty-valuation.enum";
import ReviewSolicitor from "./review-solicitor";
import { useMemo } from "react";

function ReviewConveyancing() {
  const applicationStep1FormData = useAppSelector((state) => state.app.ApplicationStep1Slice.formData);
  const applicationStep3FormData = useAppSelector((state) => state.app.ApplicationStep3Slice.formData);
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const { foundCurrent, foundProposed } = useMemo(() => {
    const foundCurrent = applicationStep1FormData.household.owners.some(item => item.myinfo.uinfin === loginUser?.uinfin);
    const foundProposed = applicationStep1FormData.household.incoming_owners.some(item => item.myinfo.uinfin === loginUser?.uinfin);
    return { foundCurrent, foundProposed }
  }, [loginUser?.uinfin, applicationStep1FormData])

  return (
    <div style={{ padding: 24 }}>
      <P2TextDescription required color="#000" title="Conveyancing" />
      <div
        style={{
          marginTop: 32,
        }}
      >
        {foundProposed &&         
          <TextInfo
            variant="column"
            title={"Proposed Holding Type"}
            titleWeight="700"
            description={
              <>
                <div
                  style={{
                    marginTop: 5,
                    fontWeight: 400,
                    marginBottom: applicationStep3FormData.holding_type === HoldingTypeEnum.tenancy_in_common ? 16 : 0,
                  }}
                >
                  {applicationStep3FormData.holding_type === HoldingTypeEnum.sole_ownership && "Sole Ownership"}
                  {applicationStep3FormData.holding_type !== HoldingTypeEnum.sole_ownership && proposedHousingTypeItems.find((e) => e.value === applicationStep3FormData.holding_type)?.title}
                </div>
                {applicationStep3FormData.holding_type === HoldingTypeEnum.tenancy_in_common && <TenancyInCommonTable tenancyData={applicationStep3FormData.tenancy_in_common} />}
              </>
            }
          />}

        <div style={{ marginTop: 32 }}>
          <QuestionAnswer question={"Are all owners willing and able to attend the completion appointment in person?"} answer={applicationStep3FormData.attend_hdb_in_person ? "Yes" : "No"} />
        </div>
        <ReviewSolicitor foundCurrent={foundCurrent} foundProposed={foundProposed}/>
        {applicationStep3FormData?.valuation?.length > 0 && foundProposed && (
          <div style={{ display: "flex", flexDirection: "column", gap: 32, marginTop: 32 }}>
            <QuestionAnswer question={"Valuation options to determining the market value of the flat:"} answer={Stamp_Duty_Valuation.find((item) => item.value === applicationStep3FormData?.valuation)?.description ?? "-"} />
            {applicationStep3FormData?.valuation === StampDutyValuationEnum.own_opinion && !isNaN(Number(applicationStep3FormData?.estimated_market_value)) && (
              <>
                <QuestionAnswer question={"Market value of the flat"} answer={applicationStep3FormData.estimated_market_value ? `SGD$${applicationStep3FormData.estimated_market_value}` : "-"} />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ReviewConveyancing;